import { useEffect as t } from "react";
function f(e) {
  t(() => {
    document.title = e;
  }, [e]);
}
export {
  f as useTitle
};
//# sourceMappingURL=title.js.map
